export default {
   setTokenCookie: token => {
      document.cookie = `token=${ token }; domain=.${ window.location.hostname }; path=/;`; 
   },

   removeTokenCookie: () => {
      document.cookie = `token=; domain=.${ window.location.hostname }; path=/; Max-Age=0;`
   }
}